import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { useLocation } from '@reach/router';
import { getSpanishBookPath } from '../../constants/spanish-gc';
// import Image from '../Image/Image'
import logo from '../../images/newlogo.png';
import iconArrowUp from '../../images/icon-arrow-up.svg';
import SocialLinks from '../SocialLinks/SocialLinks';

export default function FooterComponent() {
  const location = useLocation();
  const isSpanishGcPage = location.pathname.startsWith('/cs');
  const logoPath = isSpanishGcPage ? getSpanishBookPath() : '/';
  const [isScrolling, setIsScrolling] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    function handleScroll() {
      const scroll = window.scrollY || window.pageYOffset;
      setIsScrolling(scroll >= 100);
    }

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // detect mobile viewport to adjust footer link layout
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mq = window.matchMedia('(max-width: 768px)');
    const handleMq = (e) => setIsMobile(e.matches);

    // set initial
    setIsMobile(mq.matches);

    // listen for changes
    if (mq.addEventListener) {
      mq.addEventListener('change', handleMq);
    } else {
      mq.addListener(handleMq);
    }

    return () => {
      if (mq.removeEventListener) {
        mq.removeEventListener('change', handleMq);
      } else {
        mq.removeListener(handleMq);
      }
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="site-footer">
      <div className="wrapper wrapper-xl wrapper-footer pd-x-md">
        <div className="footer-top">
          <div className="block">
            <div className="footer-logo brand-logo">
              <Link to={logoPath}>
                <img src={logo} alt="Logo" />
              </Link>
            </div>
            <div className="footer-text footer-note">
              <p>
                Lineage Journey is a 501(c)(3) nonprofit (EIN: 93-2464252) and is a multi-faceted educational tool
                designed to help you understand your spiritual heritage and explore the links between the past, present
                and future. Donations are tax-deductible as allowed by law.
              </p>
            </div>
            <ul className="footer-nav footer-nav-1">
              <li className="fn-team">
                <Link to="/team/">The Team</Link>
              </li>
              <li className="fn-shop">
                <Link to="/shop/">Shop</Link>
              </li>
              <li className="fn-give">
                <Link to="/give/">Give</Link>
              </li>
              {isMobile && (
                <li className="fn-privacy">
                  <Link to="/policies/?tab=privacy-policy">Privacy Policy</Link>
                </li>
              )}
            </ul>
            <ul className="footer-nav footer-nav-2">
              <li className="fn-about">
                <Link to="/about/">About</Link>
              </li>
              <li className="fn-contact">
                <Link to="/contact/">Contact</Link>
              </li>
              <li>
                <Link to="/language/">Languages</Link>
              </li>
              {isMobile && (
                <li className="fn-cookie">
                  <Link to="/policies/?tab=cookie-policy">Cookie Preferences</Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="block">
            <div className="footer-logo"></div>
            <div className="footer-text footer-copyright">
              <p>© {new Date().getFullYear()} - Present Lineage Journey</p>
              {/* show policy links here only on non-mobile to avoid duplicates */}
              {!isMobile && (
                <>
                  <Link to="/policies/?tab=privacy-policy" className="footer-link">
                    Privacy Policy
                  </Link>
                  <Link to="/policies/?tab=cookie-policy" className="footer-link">
                    Cookie Preferences
                  </Link>
                </>
              )}
            </div>
            {/* Show social links in footer only on desktop */}
            {!isMobile && <SocialLinks className="footer-social" />}
          </div>
        </div>
      </div>
      <div href="#" className={`btn btn-scroll-top  ${isScrolling ? 'scrolling' : ''}`} onClick={scrollToTop}>
        <img src={iconArrowUp} alt="Arrow Up" />
      </div>
    </footer>
  );
}
